import { ISelectFilterOption } from '../../../shop-ui/components/search-page/interfaces';

export const generateSizeFilterOptions = (input: any): ISelectFilterOption[] =>
    input.map(filterOption => ({
        value: filterOption.value,
        label: filterOption.value,
        selected: filterOption.selected,
        disabled: filterOption.disabled,
    }));
